<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Rebuild Complete</span>
        <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
    </div>
    <div class="ttmodal__body">
        <div class="input-container">
            <span class="label">Implement</span>
            <span class="label">{{implementName}}</span>
        </div>

        <div class="input-container">
            <span class="label">Cycle No</span>
            <span class="label">{{cycleNo}}</span>
        </div>
        <div class="input-container">
            <span class="label">Date Rebuild Started</span>
            <span class="input-icon input-icon--mat cursor-pointer get-date-icon">
                <i class="material-icons">date_range</i>
            </span>
            <input type="text" [matDatepicker]="picker" class="get-Input-date"
                   [(ngModel)]="startDate" 
                   readonly="readonly" style="color: black">
            <mat-datepicker #picker></mat-datepicker>
        </div>
      
        <div class="input-container">
            <span class="label">Date Rebuild End</span>
            <span class="input-icon input-icon--mat cursor-pointer get-date-icon" (click)="picker1.open()" >
                <i class="material-icons">date_range</i>
            </span>
            <input type="text" [matDatepicker]="picker1" class="get-Input-date"
                   [min]="startDate"  placeholder="Choose a date"
                   [(ngModel)]="eventDate" 
                   readonly="readonly" style="color: black">
            <mat-datepicker #picker1></mat-datepicker>
        </div>
        <span class="label" style=" font-weight: 600;">Targets</span>
        <div class="input-container">
            <span class="label">Hours</span>
            <span class="input-icon get-icon">Hours</span>
            <input type="number"  min="0" [(ngModel)]="hours"  step="any" class="get-Input" />
        </div>
        <div class="input-container">
            <span class="label">BCM</span>
            <span class="input-icon get-icon">m³</span>
            <input type="number"  min="0" [(ngModel)]="bcm"  step="any"   class="get-Input"/>
        </div>
        <div class="input-container">
            <span class="label">Tonnage</span>
            <span class="input-icon get-icon">Tons</span>
            <input type="number"  min="0" [(ngModel)]="tons"  step="any"   class="get-Input"/>
        </div>
       
        
        <div class="margin-bottom-16">Comment</div>
        <textarea rows="4" maxlength="256" [(ngModel)]="comment"  class="textAreaComment"
                  placeholder="Enter a comment about this Rebuild Completion. "
                 ></textarea> 
    </div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" [class.loading]="savingChanges" (click)="saveChanges()"><span class="button__text">Save</span></a>
    </div>
</div>